// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactDom from "react-dom";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var RefManagerApiSig = {
  name: "RefManagerApi"
};

var RefManagerApi = ContextMaker$LiteracyplanetClientFlags.Make(RefManagerApiSig);

function V3RefManager$RefManagerProvider(props) {
  var lookup = React.useRef([]);
  var makeCallbackLookupRef = function (id) {
    return function (param) {
      if (param == null) {
        lookup.current = lookup.current.filter(function (param) {
              return param[0] !== id;
            });
        return ;
      } else {
        lookup.current = Belt_Array.some(lookup.current, (function (param) {
                return param[0] === id;
              })) ? Belt_Array.map(lookup.current, (function (param$1) {
                  var id$1 = param$1[0];
                  if (id$1 === id) {
                    return [
                            id$1,
                            param
                          ];
                  } else {
                    return [
                            id$1,
                            param$1[1]
                          ];
                  }
                })) : Belt_Array.concat(lookup.current, [[
                  id,
                  param
                ]]);
        return ;
      }
    };
  };
  var lookupRef = function (id) {
    return Belt_Option.flatMap(Caml_option.undefined_to_opt(lookup.current.find(function (param) {
                        return param[0] === id;
                      })), (function (param) {
                  return Caml_option.some(param[1]);
                }));
  };
  return React.createElement(RefManagerApi.Provider.make, {
              value: {
                makeCallbackLookupRef: makeCallbackLookupRef,
                lookupRef: lookupRef
              },
              children: props.children
            });
}

var RefManagerProvider = {
  make: V3RefManager$RefManagerProvider
};

function V3RefManager$MakeRefContainer(props) {
  var children = props.children;
  var className = props.className;
  var __element = props.element;
  var element = __element !== undefined ? __element : "div";
  var match = Curry._1(RefManagerApi.use, undefined);
  var cbRef = Curry._1(match.makeCallbackLookupRef, props.id);
  if (element === "span") {
    return React.createElement("span", {
                ref: Caml_option.some(cbRef),
                className: className
              }, children);
  } else if (element === "p") {
    return React.createElement("p", {
                ref: Caml_option.some(cbRef),
                className: className
              }, children);
  } else if (element === "li") {
    return React.createElement("li", {
                ref: Caml_option.some(cbRef),
                className: className
              }, children);
  } else if (element === "ul") {
    return React.createElement("ul", {
                ref: Caml_option.some(cbRef),
                className: className
              }, children);
  } else {
    return React.createElement("div", {
                ref: Caml_option.some(cbRef),
                className: className
              }, children);
  }
}

var MakeRefContainer = {
  make: V3RefManager$MakeRefContainer
};

var use = RefManagerApi.use;

function V3RefManager$Portal(props) {
  var children = props.children;
  var match = Curry._1(use, undefined);
  return Belt_Option.mapWithDefault(Curry._1(match.lookupRef, props.id), null, (function (overlay) {
                return ReactDom.createPortal(children, overlay);
              }));
}

var Portal = {
  make: V3RefManager$Portal
};

var Provider;

var Ref;

export {
  RefManagerApiSig ,
  RefManagerApi ,
  RefManagerProvider ,
  MakeRefContainer ,
  use ,
  Provider ,
  Ref ,
  Portal ,
}
/* RefManagerApi Not a pure module */
